import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { CustomAdapter, CustomDateParserFormatter } from '../filtersafe/filtersafe.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { CalendarEndDateComponent } from './calendar-enddate.component';
import { CustomDatepickerI18nService, I18n } from '../../../../services/datepicker';

@NgModule({
  declarations: [CalendarEndDateComponent],
  exports: [CalendarEndDateComponent],
  imports: [CommonModule, NgbModule, NgxMaskDirective],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18nService },
    provideNgxMask(),
  ],
})
export class CalendarEndDateModule {}
